import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useUpdate } from "@/hooks/queries";
import { useOrganizationContextDetail } from "@/modules/organization/organization-context";
import { parseDate } from "@/utilities/date";

import InterventionForm from "../InterventionForm";

const InterventionEdit = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useUpdate("interventions", model.id);
  const { contextOrganization } = useOrganizationContextDetail();

  const initialValues = {
    name: model.name,
    description: model.description,
    application_date: parseDate(model.application_date),
    scheduled_date: parseDate(model.scheduled_date) ?? "",
    users: model?.users?.map((data) => ({
      value: data.id,
      label: data.name + " (" + data.email + ")",
    })),
    template: model.intervention_template_id,
    interventionType: model.intervention_type_id,
    sub_type: model.intervention_sub_type_id,
    cost: model.cost,
    cost_type: model.cost_type,
    min_days_delay: model.min_days_delay,
    max_days_delay: model.max_days_delay,
    progress: model.progress,
    provider: model.provider ?? contextOrganization?.label,
  };

  return (
    <InterventionForm
      model={model}
      mutation={mutation}
      saveButtonLabel={t("global:update")}
      initialValues={initialValues}
    />
  );
};

InterventionEdit.propTypes = {
  model: PropTypes.object.isRequired,
};

export default InterventionEdit;
